module.exports = __webpack_public_path__ + "static/media/sidebar-2.4af6469c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sidebar-2.jpg
// module id = 1089
// module chunks = 0